import React, { useState } from 'react';

const faqsData = [
  {
    question: 'What are desiccants?',
    answer: `Desiccants are substances that are used to absorb moisture from the air and keep an environment dry. They're commonly used to prevent moisture-related damage in various products, such as electronics, food, pharmaceuticals, medical tools, textiles, clothing, automotive, cosmetics, aerospace and defense, and many more. Desiccants help control humidity and prevent mold, rust, or spoilage caused by excess moisture.`
  },
  {
    question: 'What type of desiccant is best for my product?',
    answer: `Choosing the right desiccant for your product depends on a few factors, including the type of product you're trying to protect, the environment it will be stored in, and the moisture control needs. Here’s a breakdown of the most common desiccants and the best uses for each:
    <br>
    <br>
    <ol>
      <li>
      
      <strong>1. Silica Gel</strong>
      
        <br>
        <br>
            <strong>Best For</strong>: Electronics, clothing, shoes, packaged food, pharmaceuticals, leather, textiles, etc.
        <br>
        <br>
            Silica gel is one of the most commonly used desiccants because it’s effective, non-toxic, and can be easily packaged in small packets. It is particularly useful for protecting items sensitive to moisture and condensation, like electronics or food.

      </li>

      <br>

      <li>
      
        <strong>2. Clay Dessicants</strong>
        
        <br>
        <br>
            <strong>Best For</strong>: Electronics, clothing, shoes, packaged food, pharmaceuticals, leather, textiles, etc.
        <br>
        <br>
            Clay desiccants are inexpensive alternative to other moisture control methods. They are non-toxic and chemically inert, making them safe to use in various applications. They do not release harmful substances or residues, making them environmentally friendly and suitable for use in sensitive products like food and pharmaceuticals.

      </li>

      <br>

      <li>
      
        <strong>3. Top-Dri Dessicant</strong>
        
        <br>
        <br>
            <strong>Best For</strong>: Large storage areas, shipping containers, airline cabins, boats, cars, storage areas and highly humid environments (e.g., coastal areas).
        <br>
        <br>
            Top-Dri has calcium chloride and possesses a high moisture absorption capacity, which makes it ideal for environments with very high humidity or for products that need a lot of moisture control, such as shipping containers and highly humid environments

      </li>

      <br>

      <li>
      
        <strong>4. Molecular Sieves</strong>
        
        <br>
        <br>
            <strong>Best For</strong>: High-precision moisture control, such as in pharmaceuticals, electronics, and high-value items.
        <br>
        <br>
            Molecular sieves are fast adsorbing and a more advanced type of desiccant that can absorb moisture down to very low humidity levels. They are ideal for applications requiring precise moisture control, such as in pharmaceuticals, electronics, food packaging, and some chemical industries.

      </li>

      <br>

      <li>
      
        <strong>5. Activated Carbon</strong>
        
        <br>
        <br>
            <strong>Best For</strong>: Moisture and odor control, ideal for things like shoes, bags, and products that also need to reduce smells.
        <br>
        <br>
            Activated carbon not only absorbs moisture but also absorbs odors, making it useful for products that are sensitive to both moisture and odor (e.g., clothing or leather goods).

      </li>
    </ol>`
  },
  {
    question: 'What are oxygen absorbers?',
    answer: `Oxygen absorbers are small packets or sachets that contain a substance designed to absorb the oxygen present in an enclosed space. Their primary purpose is to create a low-oxygen environment, which helps preserve the quality and shelf life of products that are sensitive to oxidation, such as food, pharmaceuticals, and certain chemicals.`
  },
  {
    question: 'What are the common uses of oxygen absorbers?',
    answer: `
    <ol>
    
    <li>
        <strong\>Food Preservation</strong>:
        <br>
        <br>
        <ul>
            <li>• Oxygen absorbers are frequently used in food packaging to maintain freshness, preserve flavor, and prevent spoilage. They are particularly effective for foods like dried fruits, jerky, powdered foods, and vacuum-sealed products.</li>
            <li>• They prevent the growth of aerobic bacteria, molds, and yeasts that thrive in the presence of oxygen.</li>
            <li>• They help to maintain the texture, flavor, and nutritional quality of the food.</li>
        </ul>
    </li>

    <br>
    <br>

    <li>
        <strong\>Pharmaceuticals</strong>:
        <br>
        <br>
        <ul>
            <li>• Oxygen absorbers are used in the packaging of medications, particularly for those that are sensitive to oxidation. Some active ingredients in drugs can degrade when exposed to oxygen, so the absorbers help maintain their potency.</li>
        </ul>
    </li>

    <br>
    <br>

    <li>
        <strong\>Preservation of Other Products</strong>:
        <br>
        <br>
        <ul>
            <li>• Items such as seeds, spices, and certain chemicals are also packed with oxygen absorbers to prolong their shelf life and preserve their effectiveness.</li>
        </ul>
    </li>

    <br>
    <br>
    
    </ol>
    `
  },
  {
    question: 'Should I use a desiccant or an oxygen absorber?',
    answer: `Desiccants and oxygen absorbers are both used for preserving the quality of products, but they work in different ways and serve distinct purposes. Here's a comparison of the two:
    
    <br>
    <br>

    <strong>Purpose</strong>:
    <br>
    <br>
    <ul>
      <li>• Desiccants control moisture, preventing damage from humidity.</li>
      <li>• Oxygen absorbers reduce oxygen to prevent oxidation and spoilage.</li>
    </ul>

    <br>

    <strong>Effect on Environment</strong>:
    <br>
    <br>
    <ul>
      <li>• Desiccants keep the environment dry by pulling moisture from the air.</li>
      <li>• Oxygen absorbers create an oxygen-depleted environment by absorbing oxygen.</li>
    </ul>

    <br>

    <strong>Products</strong>:
    <br>
    <br>
    <ul>
      <li>• Desiccants are used in products sensitive to humidity.</li>
      <li>• Oxygen absorbers are used for products that need to be protected from oxidation.</li>
    </ul>

    <br>
    In some cases, both may be used together, especially in food packaging, to address both moisture and oxygen-related issues.`
  },
  {
    question: `I am using a desiccant, but it seems like moisture still penetrates the environment. Why?`,
    answer: `If you're using a desiccant but still noticing moisture penetrating the environment, several factors could be contributing to the issue. Here are some possible reasons:

    <br>
    <br>
    <ol>
        <li>
        <strong>1. Inadequate Moisture Barrier Packaging</strong>:

        <br>
        <br>
        
        <ul>
            <li>•	<strong>Weak Packaging Materials</strong>: If the outer packaging is not moisture-resistant enough, moisture can still seep in. Materials like regular polyethylene or polypropylene might not provide a strong enough barrier against moisture. You need to use moisture-resistant materials like <strong>MBB (moisture barrier bags)</strong> or multi-layer laminates with aluminum foil, which are better at keeping moisture out.</li>
            <li>•	<strong>Packaging Integrity</strong>: If the packaging has small tears, holes, or isn't sealed properly, moisture can infiltrate. Ensure the package is vacuum-sealed or heat-sealed tightly, leaving no room for external humidity to enter.</li>
        </ul>
        </li>

        <br>

        <li>
        <strong>2. Desiccant Saturation</strong>:
        
        <br>
        <br>

        <ul>
            <li>•	<strong>Desiccant Has Reached Its Capacity</strong>: Desiccants can only absorb a finite amount of moisture. If the desiccant has already absorbed its maximum capacity, it will no longer be effective. If you've had the package exposed to humid conditions for a prolonged period or the desiccant has been in use for a while, it may be saturated.</li>
            <li>•	<strong>Check Desiccant Condition</strong>: Some desiccants, like silica gel, change color or show signs of saturation. If you are using an indicator desiccant, check if it has turned from its original color (e.g., blue to pink) or is showing signs of moisture accumulation.</li>
        </ul>
        </li>
        
        <br>

        <li>
        <strong>3. Excessive Humidity or Temperature Changes</strong>:
        
        <br>
        <br>

        <ul>
            <li>•	<strong>High Humidity Levels</strong>: If the surrounding environment is very humid, the desiccant may not be able to absorb enough moisture to maintain the desired dry conditions. Desiccants work best when the humidity is within a manageable range. If the relative humidity is too high (e.g., over 60–70%), the desiccant might struggle to perform effectively.</li>
            <li>•	<strong>Temperature Fluctuations</strong>: Significant changes in temperature can cause condensation inside the package. If the package is stored in an area with fluctuating temperatures, moisture could condense inside, rendering the desiccant ineffective. Ensure that the product is stored in a controlled environment to minimize temperature variations.</li>
        </ul>
        </li>

        <br>
        
        <li>
        <strong>4. Inadequate Amount of Desiccant</strong>:

        <br>
        <br>

        <ul>
            <li>•	<strong>Too Little Desiccant</strong>: If the amount of desiccant used is insufficient for the size of the package or the moisture load, it may not be able to keep up with the moisture entering the package. Make sure you're using the recommended amount of desiccant based on the volume of the product and the environmental conditions.</li>
            <li>•	<strong>Wrong Type of Desiccant</strong>: Some desiccants, like silica gel, may be more effective in low-humidity environments but less so in very high humidity. Consider whether the desiccant type is suited to the conditions your product is facing.</li>
        </ul>
        </li>
        
        <br>

        <li>
        <strong>5. Improper Packaging Process</strong>:

        <br>
        <br>

        <ul>
            <li>•	<strong>Improper Sealing of the Package</strong>: If the package is not sealed properly (e.g., during the sealing process or packaging line), moisture could enter. This could be due to weak seals or improper sealing techniques. Ensure you're using proper heat-sealing or vacuum-sealing techniques, and check for any potential air gaps.</li>
            <li>•	<strong>Handling and Exposure to Humidity During Packing</strong>: If the desiccant or the product is exposed to moisture before packaging (e.g., during storage or transport), it might already be compromised by the time it's sealed in the package. Ensure desiccants are dry and the packaging process takes place in a controlled environment.</li>
        </ul>
        </li>

        <br>

        <li>
        <strong>6. Leakage Due to Overloaded Packaging</strong>:

        <br>
        <br>

        <ul>
            <li>•	<strong>Too Much Product in a Package</strong>: If the product is packed too tightly or exceeds the recommended space, it might limit airflow and the desiccant's ability to effectively absorb moisture. The desiccant might not be able to circulate well within the package, leading to areas of higher humidity.</li>
        </ul>
        </li>

        <br>

        <li>
        <strong>7. Improper Storage Conditions</strong>:

        <br>
        <br>

        <ul>
            <li>•	<strong>Storage in High-Humidity Areas</strong>: If the packaged goods with desiccants are stored in high-humidity environments (e.g., warehouses, shipping containers), moisture can still seep into the package over time. Storing products in a dry, temperature-controlled area can help prevent external moisture from entering the package.</li>
        </ul>
        </li>

        <br>

        <li>
        <strong>Solutions</strong>:

        <br>
        <br>

        <ul>
            <li>1.  <strong>Check the seal</strong> of the packaging and ensure it's airtight.</li>
            <li>2.	<strong>Increase the amount</strong> of desiccant used if you're dealing with a particularly high moisture load.</li>
            <li>3.	<strong>Switch to a better moisture barrier</strong> material for the packaging, such as MBB (moisture barrier bag) with an aluminum layer.</li>
            <li>4.	<strong>Ensure the desiccant is fresh</strong> and not already saturated.</li>
            <li>5.	<strong>Consider using a combination of desiccants and oxygen absorbers</strong> to tackle both moisture and oxygen, as they address different preservation factors.</li>
        </ul>
        </li>
    </ol>

    <br>

    If you’re still having issues, a more specific review of your packaging process and storage conditions might be necessary to pinpoint the exact cause.

    `
  },
  {
    question: 'How will I know that the desiccant is still fresh?',
    answer: `To determine if a desiccant is still fresh and effective, there are several methods you can use. Here are some key ways to check the freshness and effectiveness of a desiccant:
    
    <br>
    <br>

    <strong>1. Moisture Indicator (Color Change)</strong>:

    <br>
    <br>

    <ul>
        <li>• <strong>Desiccants like silica gel</strong> often have built-in moisture indicators. These are typically <strong>blue (dry)</strong> and turn <strong>pink (moist)</strong> as they absorb moisture.</li>
        <li>• <strong>For example</strong>:
            <ul style="list-style-type: none; padding-left: 40px;">
                <li>• <strong>Blue silica gel</strong> turns pink when saturated with moisture.</li>
                <li>• <strong>Orange silica gel</strong> changes from orange to green.</li>
            </ul>
        </li>
        <li>• <strong>Check the color</strong>: If the desiccant indicating gels have changed color, it indicates that it's absorbed moisture and may need to be replaced or reactivated.</li>
        <li>• <strong>Use a Humidity Indicating Card (HIC)</strong> These cards help determine whether the environment inside a package or container is too humid for the product, and they can be used with desiccants or other moisture-controlling products to ensure optimal conditions</li>
    </ul>

    <br>

    <strong>2. Signs of Saturation</strong>:

    <br>
    <br>

    <ul>
        <li>• If the desiccant appears <strong>damp</strong> or <strong>wet</strong> (especially in the case of silica gel or clay-based desiccants), it means the desiccant has absorbed its maximum capacity of moisture and is no longer effective.</li>
        <li>• <strong>Physical appearance</strong>: Desiccants that are still fresh usually appear dry and in their original form, whereas saturated ones might look discolored, clumpy, or moist.</li>
    </ul>

    <br>
    
    <strong>3. Desiccant Packet Condition</strong>:

    <br>
    <br>
    
    <ul>
        <li>• <strong>Check the packet</strong> for signs of damage, leaks, or tears. If the packet is compromised, moisture can enter, rendering the desiccant ineffective even if it hasn’t absorbed much moisture yet.</li>
        <li>• Ensure that the desiccant packet itself is intact, with no punctures, rips, or tears.</li>
    </ul>
    
    <br>

    <strong>4. Time and Storage Conditions</strong>:

    <br>
    <br>

    <ul>
        <li>• <strong>Exposure to moisture</strong>: Desiccants exposed to humid environments for a long period of time (especially if they're stored in non-sealed packaging) can absorb moisture from the air and lose their effectiveness even before they are used.</li>
        <li>• <strong>Storage</strong>: If the desiccants have been stored in a humid environment, they may already be partially or fully saturated.</li>
    </ul>
    
    <br>

    <strong>5. Moisture Detection in the Package</strong>:

    <br>
    <br>

    <ul>
        <li>• <strong>Signs of moisture in the packaging</strong>: If you notice visible signs of moisture or mold within the packaging, it indicates that the desiccant is no longer doing its job.</li>
        <li>• <strong>Feel the product</strong>: If the product inside the package feels damp or appears to have degraded in any way (e.g., discolored, sticky, or moldy), this could indicate that the desiccant is no longer functioning as intended.</li>
    </ul>
    `
  },
  {
    question: 'Can desiccants be regenerated?',
    answer: `Yes, some but not all types of desiccants can be regenerated. However, you need to subject them to very high temperatures for several hours. Regenerated desiccants’ quality degrades because they  lose their capacity to adsorb moisture, for example, silica gel has a 30% adsorption capacity, once regenerated, it goes down and will saturate faster. 
    
    <br>
    <br>
    Because of the high energy consumption, it is still more cost-effective to use fresh desiccants than to regenerate them. `
  },
  {
    question: `Adsorb vs Absorb`,
    answer: `
    The difference between adsorb and absorb in the context of desiccants is:

    <br>
    <br>

    <strong>Adsorption (Surface Binding)</strong>
    <li>The desiccant <strong>traps moisture on its surface</strong> rather than incorporating it into its structure. Desiccants such as silica gel, clay, and molecular sieve adsorb water vapor onto their porous surfaces.</li>

    <br>

    <strong>Absorption (Internal Uptake)</strong>
    <li> The desiccant <strong>takes in moisture into its structure</strong>, often causing a chemical change. Calcium chloride absorbs water and forms a liquid brine, this is why you need a product such as Top-Dri that transforms this liquid into gel to trap the moisture in place.</li>

    <br>

    <strong>Quick Trick to Remember</strong>:
    <li><strong>Adsorption</strong> = "Sticks to the surface"</li>
    <li><strong>Absorption</strong> = "Soaks inside"</li>
    `
  }
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="FAQs" className="w-full min-h-screen bg-white flex justify-center items-center py-12">
      <div className="container mx-auto px-4">
        {/* Title and Subtitle */}
        <div className="text-center mb-12">
          <h2 className="text-lg font-semibold text-gray-500 uppercase tracking-wider">
            General FAQs
          </h2>
          <h1 className="text-4xl font-semibold text-[#30779b] mt-3">
            Frequently Asked Questions
          </h1>
          <p className="text-base text-gray-600 mt-2">
            Everything you need to know about the product
          </p>
        </div>

        {/* FAQ List */}
        <div className="max-w-2xl mx-auto border-t border-gray-200">
          {faqsData.map((faq, index) => (
            <div key={index} className="border-b border-gray-200">
              <button
                className="w-full flex justify-between items-center py-4 text-left text-gray-800 text-lg font-medium focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="text-gray-500 text-xl">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className="text-gray-600 px-4 pb-4 text-justify" dangerouslySetInnerHTML={{ __html: faq.answer }} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
